<template>
    <div :class="styles" class="px-8 py-5">
        <div class="grid grid-cols-6 gap-3">
            <div class="col-span-6 md:col-span-4">
                <h3 class="text-xl leading-6 font-medium text-gray-50">
                    {{ title }}
                </h3>
                <p class="mt-1 text-md text-gray-200" v-if="description">
                    {{ description }}
                </p>
            </div>
            <div class="col-span-6 md:col-span-2 text-right">
                <slot name="header-right"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: { required: true },
        description: { required: false },
        variant: { default: 'primary' },
    },
    computed: {
        styles() {
            switch (this.variant) {
            case 'primary':
            default:
                return 'bg-brand-blue';
            }
        },
    },
};
</script>
